// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/pictos/modal-alert.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  z-index: 99;
  display: none;
  align-items: center;
  justify-content: center;
}
.modal.modal-disconnect {
  z-index: 17;
  left: 50px;
}
.modal.modal--documents {
  z-index: 100;
}
.modal .modal__backdrop {
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 0;
}
@media (max-width: 575px) {
  .modal .modal__backdrop {
    background: transparent;
  }
}
.modal .modal__close {
  width: 1.875rem;
  height: 1.875rem;
  padding: 0px;
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  border-radius: 50%;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.25);
  border: none;
  outline: none;
  padding: 0.375rem;
  color: #00666F;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FDFBFB;
}
.modal .modal__inner {
  position: relative;
  z-index: 5;
  background: #FDFBFB;
  border-radius: 20px;
  padding: 10px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.25);
  padding: 0.75rem;
  color: #00666F;
  max-width: 80%;
  width: 50rem;
  transition: all 350ms;
  margin-bottom: -100%;
  max-height: 80%;
  overflow: hidden;
  overflow-y: auto;
}
.modal .modal__inner.modal--setting {
  box-shadow: none;
}
.modal.modal--opened {
  display: flex;
}
.modal.modal--show .modal__inner {
  margin-bottom: 0;
}
.modal .modal__title {
  font-size: "Exo", sans-serif;
  font-size: 1rem;
  margin: 0px 0px 1rem;
  text-align: center;
  font-weight: 600;
  color: inherit;
}
.modal .modal__body {
  font-size: 0.875rem;
  font-weight: 500;
}
.modal .modal__alert {
  font-size: 0.875rem;
  color: #FDFBFB;
  background: #FF4958;
  padding: 0.5rem 0.625rem;
  border-radius: 1rem;
  font-weight: 600;
  position: relative;
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.modal .modal__alert::before {
  content: "";
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: contain;
  margin-right: 0.625rem;
}
.modal .modal__icon {
  width: 2.25rem;
  height: 2.25rem;
  margin: 0px auto 1rem;
  border-radius: 50%;
  background: #1DADB5;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal .modal__icon i {
  color: #FDFBFB;
}
.modal .modal__buttons {
  margin-top: 1rem;
  text-align: center;
}
.modal .modal__buttons .button + .button {
  margin-left: 1.125rem;
}
.modal.modal--confirm2 .modal__body, .modal.modal--confirm .modal__body {
  font-weight: 600;
  text-align: center;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}
.modal.modal--alert .modal__inner, .modal.modal--confirm .modal__inner, .modal.modal--confirm2 .modal__inner, .modal.modal--progress .modal__inner {
  width: 22rem;
}
.modal.modal--alert .modal__body {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.modal.modal--documents .modal__buttons {
  margin-bottom: 1rem;
}
.modal.modal--documents .modal__buttons .button {
  min-width: 8.5rem;
  max-width: 100%;
}
@media (max-width: 575px) {
  .modal.modal--documents .modal__buttons {
    text-align: right;
  }
  .modal.modal--documents .modal__buttons .button {
    font-size: 0.75rem;
  }
  .modal.modal--documents .modal__inner {
    max-width: 100%;
    max-height: calc(100% - 60px);
    width: 100%;
    height: calc(100% - 60px);
    margin-top: auto;
    border-radius: 0px;
  }
  .modal.modal--documents .modal__close {
    display: none;
  }
  .modal.modal--documents .modal__body,
  .modal.modal--documents .modal__content {
    height: 100%;
    width: 100%;
  }
  .modal.modal--documents .modal__content {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }
  .modal.modal--documents .documents,
  .modal.modal--documents .documents__content {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    overflow: hidden;
  }
  .modal.modal--documents .modal__content {
    position: relative;
  }
  .modal.modal--documents .documents {
    flex: 1 1 auto;
  }
  .modal.modal--documents .documents__listwrapper {
    max-height: 100%;
    border-radius: 0px;
    box-shadow: none;
    overflow-x: hidden;
  }
  .modal.modal--documents .button--download-all {
    position: absolute;
    bottom: 1rem;
    left: 0px;
  }
}
.modal.modal--setting .modal__inner {
  width: 42rem;
}
.onetoone-type-patient .modal.modal--setting .modal__inner {
  width: 56rem;
}
.modal.modal--setting .modal__title {
  padding: 0.375rem 0px 1rem;
  font-size: 1.375rem;
  font-weight: 600;
  border-bottom: 2px solid rgb(220, 216, 214);
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.modal.modal--light .modal__backdrop {
  display: none;
}
.modal.modal--light.modal--opened {
  display: flex;
  align-items: flex-end;
  margin: 0 0 115px 40px;
  justify-content: flex-start;
}
.modal.modal--light.modal--opened .modal__inner {
  width: auto;
  background: #333C50;
  color: #fff;
}
.modal.modal--light.modal--opened .modal__title {
  text-align: left;
  margin: 0 0 6px 0;
}
.modal.modal--light.modal--opened .modal__body {
  font-weight: normal;
}
.modal.modal--light.modal--opened .modal__close {
  float: right;
  font-size: 9px;
  margin-top: -4px;
  border: 1px solid #fff;
  width: 16px;
  height: 16px;
  line-height: 14px;
  border-radius: 50%;
  text-align: center;
  background: #333C50;
  color: #fff;
  cursor: pointer;
}

@media (max-width: 575px) {
  .modal-needInteraction .modal__inner {
    transform: translateY(80%);
  }
  .modal-needInteraction .need-interaction p {
    font-size: 1rem;
  }
}

@media (max-width: 575px) {
  .main-settings-modal .modal__body,
  .main-settings-modal .modal__content,
  .main-settings-modal .tabs-wrapper {
    height: 100%;
    width: 100%;
  }
  .main-settings-modal .modal__inner {
    max-width: 100%;
    max-height: calc(100% - 60px);
    width: 100%;
    height: calc(100% - 60px);
    margin-top: auto;
    border-radius: 0px;
  }
  .main-settings-modal .modal__close {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/components/Modal.scss","webpack://./src/styles/abstracts/_functions.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAKA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJJ;AAMI;EACI,WAAA;EACA,UAAA;AAJR;AAOI;EACI,YAAA;AALR;AASI;EACI,8BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAPR;ACmCE;EDzBM;IACI,uBAAA;EAPV;AACF;AAUI;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,+CAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,cElCc;EFmCd,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBEhDO;AFwCf;AAYI;EACI,kBAAA;EACA,UAAA;EACA,mBEvDO;EFwDP,mBEfU;EFgBV,aEbA;EFcA,+CAAA;EACA,gBAAA;EACA,cElDc;EFmDd,cAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAVR;AAYQ;EACI,gBAAA;AAVZ;AAcI;EACI,aAAA;AAZR;AAgBQ;EACI,gBAAA;AAdZ;AAkBI;EACI,4BEzDQ;EF0DR,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAhBR;AAmBI;EACI,mBAAA;EACA,gBAAA;AAjBR;AAoBI;EACI,mBAAA;EACA,cEpGO;EFqGP,mBEpGK;EFqGL,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAnBR;AAqBQ;EACI,WAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,oEAAA;EACA,wBAAA;EACA,sBAAA;AAnBZ;AAuBI;EACI,cAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBEzHS;EF0HT,aAAA;EACA,uBAAA;EACA,mBAAA;AArBR;AAuBQ;EACI,cEvIG;AFkHf;AAyBI;EACI,gBAAA;EACA,kBAAA;AAvBR;AAyBQ;EACI,qBAAA;AAvBZ;AA8BQ;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA5BZ;AAoCQ;EACI,YAAA;AAlCZ;AAsCQ;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;AApCZ;AAyCQ;EACI,mBAAA;AAvCZ;AAwCY;EACI,iBAAA;EACA,eAAA;AAtChB;AC3FE;EDqIU;IACI,iBAAA;EAvCd;EAwCc;IACI,kBAAA;EAtClB;EAyCU;IACI,eAAA;IACA,6BAAA;IACA,WAAA;IACA,yBAAA;IACA,gBAAA;IACA,kBAAA;EAvCd;EAyCU;IACI,aAAA;EAvCd;EAyCU;;IAEI,YAAA;IACA,WAAA;EAvCd;EAyCU;IACI,aAAA;IACA,sBAAA;IACA,iBAAA;EAvCd;EAyCU;;IAEI,aAAA;IACA,sBAAA;IACA,iBAAA;IACA,gBAAA;EAvCd;EAyCU;IACI,kBAAA;EAvCd;EAyCU;IACI,cAAA;EAvCd;EAyCU;IACI,gBAAA;IACA,kBAAA;IACA,gBAAA;IACA,kBAAA;EAvCd;EAyCU;IACI,kBAAA;IACA,YAAA;IACA,SAAA;EAvCd;AACF;AA4CQ;EACI,YAAA;AA1CZ;AA2CY;EACI,YAAA;AAzChB;AA8CQ;EACI,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;EACA,qBAAA;EACA,sBAAA;AA5CZ;AAiDQ;EACI,aAAA;AA/CZ;AAiDQ;EACI,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,2BAAA;AA/CZ;AAgDY;EACI,WAAA;EACA,mBAAA;EACA,WAAA;AA9ChB;AAgDY;EACI,gBAAA;EACJ,iBAAA;AA9CZ;AAgDY;EACI,mBAAA;AA9ChB;AAgDY;EACI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AA9ChB;;ACjME;EDwPM;IACI,0BAAA;EAnDV;EAqDM;IACI,eAAA;EAnDV;AACF;;AC1ME;EDmQM;;;IAGI,YAAA;IACA,WAAA;EArDV;EAuDM;IACI,eAAA;IACA,6BAAA;IACA,WAAA;IACA,yBAAA;IACA,gBAAA;IACA,kBAAA;EArDV;EAuDM;IACI,aAAA;EArDV;AACF","sourcesContent":["@use '../abstracts/variables' as *;\n@use '../abstracts/functions';\n\n\n\n.modal {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    bottom: 0px;\n    right: 0px;\n    z-index: 99;\n    display: none;\n    align-items: center;\n    justify-content: center;\n\n    &.modal-disconnect {\n        z-index: 17;\n        left: 50px;\n    }\n\n    &.modal--documents{\n        z-index:100;\n    }\n\n    // Overlay\n    .modal__backdrop {\n        background: rgba(0, 0, 0, 0.8);\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        width: 100%;\n        height: 100%;\n        z-index: 0;\n    }\n    @include functions.responsiveSmartphone {\n        .modal__backdrop {\n            background: transparent;\n        }\n    }\n    // Close\n    .modal__close {\n        width: 1.875rem;\n        height: 1.875rem;\n        padding: 0px;\n        position: absolute;\n        top: 0.75rem;\n        right: 0.75rem;\n        border-radius: 50%;\n        box-shadow: 1px 1px 4px 1px rgba($color__black, 0.25);\n        border: none;\n        outline: none;\n        padding: 0.375rem;\n        color: $color__primary-dark;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: $color__white;\n    }\n\n    // Modal\n    .modal__inner {\n        position: relative;\n        z-index: 5;\n        background: $color__white;\n        border-radius: $border-radius3;\n        padding: $marge2;\n        box-shadow: 1px 1px 4px 1px rgba($color__black, 0.25);\n        padding: 0.75rem;\n        color: $color__primary-dark;\n        max-width: 80%;\n        width: 50rem;\n        transition: all 350ms;\n        margin-bottom: -100%;\n        max-height: 80%;\n        overflow: hidden;\n        overflow-y: auto;\n\n        &.modal--setting {\n            box-shadow: none;\n        }\n    }\n\n    &.modal--opened {\n        display: flex;\n    }\n\n    &.modal--show {\n        .modal__inner {\n            margin-bottom: 0;\n        }\n    }\n\n    .modal__title {\n        font-size: $font__primary;\n        font-size: 1rem;\n        margin: 0px 0px 1rem;\n        text-align: center;\n        font-weight: 600;\n        color: inherit;\n    }\n\n    .modal__body {\n        font-size: 0.875rem;\n        font-weight: 500;\n    }\n\n    .modal__alert {\n        font-size: 0.875rem;\n        color: $color__white;\n        background: $color__red;\n        padding: 0.5rem 0.625rem;\n        border-radius: 1rem;\n        font-weight: 600;\n        position: relative;\n        margin-bottom: 1rem;\n\n        display: flex;\n        flex-wrap: nowrap;\n        flex-direction: row;\n        align-items: center;\n\n        &::before {\n            content: '';\n            display: block;\n            width: 1.25rem;\n            height: 1.25rem;\n            background: functions.image('pictos/modal-alert.png', '../') no-repeat center;\n            background-size: contain;\n            margin-right: 0.625rem;\n        }\n    }\n\n    .modal__icon {\n        width: 2.25rem;\n        height: 2.25rem;\n        margin: 0px auto 1rem;\n        border-radius: 50%;\n        background: $color__primary;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        i {\n            color: $color__white;\n        }\n    }\n\n    .modal__buttons {\n        margin-top: 1rem;\n        text-align: center;\n\n        .button+.button {\n            margin-left: 1.125rem;\n        }\n    }\n\n    // VARIANT\n    &.modal--confirm2,\n    &.modal--confirm {\n        .modal__body {\n            font-weight: 600;\n            text-align: center;\n            max-width: 300px;\n            margin-left: auto;\n            margin-right: auto;\n        }\n    }\n\n    &.modal--alert,\n    &.modal--confirm,\n    &.modal--confirm2,\n    &.modal--progress {\n        .modal__inner {\n            width: 22rem;\n        }\n    }\n    &.modal--alert {\n        .modal__body {\n            text-align: center;\n            margin-left: auto;\n            margin-right: auto;\n        }\n    }\n\n    &.modal--documents {\n        .modal__buttons {\n            margin-bottom: 1rem;\n            .button {\n                min-width: 8.5rem;\n                max-width: 100%;\n            }\n        }\n        @include functions.responsiveSmartphone {\n            .modal__buttons {\n                text-align: right;\n                .button {\n                    font-size: 0.75rem;\n                }\n            }\n            .modal__inner {\n                max-width: 100%;\n                max-height: calc(100% - 60px);\n                width: 100%;\n                height: calc(100% - 60px);\n                margin-top: auto;\n                border-radius: 0px;\n            }\n            .modal__close {\n                display: none;\n            }\n            .modal__body,\n            .modal__content {\n                height: 100%;\n                width: 100%;\n            }\n            .modal__content {\n                display: flex;\n                flex-direction: column;\n                flex-wrap: nowrap;\n            }\n            .documents,\n            .documents__content {\n                display: flex;\n                flex-direction: column;\n                flex-wrap: nowrap;\n                overflow: hidden;\n            }\n            .modal__content {\n                position: relative;\n            }\n            .documents {\n                flex: 1 1 auto;\n            }\n            .documents__listwrapper {\n                max-height: 100%;\n                border-radius: 0px;\n                box-shadow: none;\n                overflow-x: hidden;\n            }\n            .button--download-all {\n                position: absolute;\n                bottom: 1rem;\n                left: 0px;\n            }\n        }\n    }\n    \n    &.modal--setting {\n        .modal__inner {\n            width: 42rem;\n            .onetoone-type-patient & {\n                width: 56rem;\n            }\n        }\n        .modal__header {\n        }\n        .modal__title {\n            padding: 0.375rem 0px 1rem;\n            font-size: 1.375rem;\n            font-weight: 600;\n            border-bottom: 2px solid rgba(220, 216, 214, 1);\n            margin-left: -0.75rem;\n            margin-right: -0.75rem;\n        }\n    }\n\n    &.modal--light{\n        .modal__backdrop{\n            display:none;\n        }\n        &.modal--opened{\n            display: flex;\n            align-items: flex-end;\n            margin: 0 0 115px 40px;\n            justify-content: flex-start;\n            .modal__inner{\n                width: auto;\n                background: #333C50;\n                color:#fff;\n            }\n            .modal__title{\n                text-align: left;\n            margin: 0 0 6px 0;\n            }\n            .modal__body{\n                font-weight:normal\n            }\n            .modal__close{\n                float: right;\n                font-size: 9px;\n                margin-top: -4px;\n                border: 1px solid #fff;\n                width: 16px;\n                height: 16px;\n                line-height: 14px;\n                border-radius: 50%;\n                text-align: center;\n                background: #333C50;\n                color:#fff;\n                cursor:pointer;\n            }\n        }\n    }\n}\n\n\n.modal-needInteraction {\n    @include functions.responsiveSmartphone {\n        .modal__inner {\n            transform: translateY(80%);\n        }\n        .need-interaction p {\n            font-size: 1rem;\n        }\n    }\n}\n\n.main-settings-modal {\n    @include functions.responsiveSmartphone {\n        .modal__body,\n        .modal__content,\n        .tabs-wrapper {\n            height: 100%;\n            width: 100%;\n        }\n        .modal__inner {\n            max-width: 100%;\n            max-height: calc(100% - 60px);\n            width: 100%;\n            height: calc(100% - 60px);\n            margin-top: auto;\n            border-radius: 0px;\n        }\n        .modal__close {\n            display: none;\n        }\n    }\n}","@use './variables' as *;\n\n/// Base path for assets (fonts, images...),\n/// should not include trailing slash\n/// @access public\n/// @type String\n$asset-base-path: '../assets' !default;\n\n/// Asset URL builder\n/// @access private\n/// @param {String} $type - Asset type, matching folder name\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the asset\n@function asset($type, $file, $before: '') {\n  @return url($before + $asset-base-path + '/' + $type + '/' + $file);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function image($file, $before: '') {\n  @return asset('images', $file, $before);\n}\n\n/// Image asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the image\n/// @require {function} asset\n@function picto($file, $before: '') {\n  @return asset('images/pictos', $file, $before);\n}\n\n/// Font asset helper\n/// @access public\n/// @param {String} $file - Asset file name, including extension\n/// @return {URL} - A `url()` function leading to the font\n/// @require {function} asset\n@function font($file, $before: '') {\n  @return asset('fonts', $file, $before);\n}\n\n\n// width < 1200px\n@mixin responsiveTablet {\n  @media (max-width: $screen-xl - 1px) {\n    @content;\n  }\n}\n\n// width < 768px OR height < 576px\n@mixin responsiveMobile {\n  @media (max-width: $screen-md - 1px), (max-height: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n// width < 576px\n@mixin responsiveSmartphone {\n  @media (max-width: $screen-sm - 1px) {\n    @content;\n  }\n}\n\n@mixin responsiveWidth($width) {\n  @media (max-width: $width) {\n    @content;\n  }\n}\n\n@mixin responsiveHeight($height) {\n  @media (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveWidthOrHeight($width, $height) {\n  @media (max-width: $width), (max-height: $height) {\n    @content;\n  }\n}\n\n@mixin responsiveNewTablet {\n  @include responsiveWidthOrHeight($screen-lg - 1px, 699px) {\n    @content;\n  }\n}","// Screen sizes\n$screen-sm: 576px;\n$screen-md: 768px;\n$screen-lg: 992px;\n$screen-xl: 1200px;\n$screen-xxl: 1440px;\n$screen-full: 1920px;\n\n// Colors\n$color__white: #FDFBFB;\n$color__red: #FF4958;\n$color__orange: #F4981C;\n$color__black: #000000;\n$color_grey: #EEE7E1;\n$color-darkgrey: #697F8C;\n\n\n$color__primary: #1DADB5;\n$color__primary-alt: #007E94;\n$color__primary-dark: #00666F;\n$color__primary-light: #D3F1F2;\n\n$color__secondary-dark: #7D748D;\n$color__secondary: #ACA6B7;\n$color__secondary-light1: #E8E5EC;\n$color__secondary-light2: #F6F5F8;\n\n\n$color__ternary: #333c50;\n\n$theme__colors: (\n    \"primary\": $color__primary, \n    \"dark\": $color__black, \n    \"danger\": $color__red, \n    \"warning\": $color__orange\n);\n\n$font__primary: 'Exo', sans-serif;\n$font__secondary: 'Inter', sans-serif;\n\n$font__ternary: 'Filson Pro', sans-serif;\n$font__quaternary: 'Omnes', sans-serif;\n\n$size__text: 1rem;\n\n$font__text: $font__primary;\n$font__title: $font__primary;\n\n$border-radius1 : 10px;\n$border-radius2 : 15px;\n$border-radius3 : 20px;\n\n$marge1:5px;\n$marge2:10px;\n$marge3:5px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
